//
// [アドイン] 個人の持ち出し履歴の全表示（サーバー対応）
//
// ./HistoryViewerModal.js
//

import React, { useEffect, useState } from 'react';
import { useEscapeClose } from '../hooks/useEscapeClose';
import DoubleConfirmModal from './doubleConfirmModal';


function HistoryViewerModal({ userId, onClose }) {
  const [records, setRecords] = useState([]);
  const [modalConfig, setModalConfig] = useState(null);
  
  useEscapeClose(onClose);

  const [userList, setUserList] = useState([]);

  useEffect(() => {
    fetch("https://newells4610.stars.ne.jp/data/userList.json", { cache: "no-store" })
      .then(res => res.json())
      .then(data => setUserList(data))
      .catch(err => {
        console.error("ユーザーリスト取得エラー", err);
        setUserList([]);
      });
  }, []);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const res = await fetch("https://newells4610.stars.ne.jp/data/checkoutrecords.json", {
          cache: "no-store"
        });
        const all = await res.json();
        const filtered = all
          .filter(rec => rec.userId === userId || rec.user === userId)
          .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        setRecords(filtered);
      } catch (err) {
        console.error("履歴取得失敗", err);
        setRecords([]);
      }
    };
    fetchHistory();
  }, [userId]);

  const user = userList.find(u => u.id === userId);
  const displayName = user?.name || userId;

  return (
    <>
      <div className="modal-overlay" style={{ zIndex: 1100 }}>
        <div className="modal-box" style={{ maxWidth: 680 }}>
          <h4>{displayName} さんの持ち出し履歴</h4>

          <div className="modal-list small-text" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            {records.length === 0 && <p>履歴はありません。</p>}
            {records.map((rec, i) => (
              <div key={i}>
                <strong>{new Date(rec.timestamp).toLocaleString()}</strong>
                {rec.items.map((it, j) => (
                  <div key={j} style={{ paddingLeft: '1em' }}>
                    {it.name}（{it.productId}）× {it.quantity}
                  </div>
                ))}
              </div>
            ))}
          </div>

          <div className="modal-actions">
            <button onClick={onClose}>閉じる</button>
          </div>
        </div>
      </div>
      
      {modalConfig && <DoubleConfirmModal {...modalConfig} />}

    </>
  );
}

export default HistoryViewerModal;
